export default __webpack_public_path__ + "static/media/moderator.1a5aa775.svg";